import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const REMOVE_PUBLISHER_FROM_WORKSPACE: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation removePublisherFromWorkspace($input: RemovePublisherFromWorkspaceInput!) {
    removePublisherFromWorkspace(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
